import { render, staticRenderFns } from "./ShowClip.vue?vue&type=template&id=0bb3ba56&"
import script from "./ShowClip.vue?vue&type=script&lang=js&"
export * from "./ShowClip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports